<template lang="html">
<div class="preferences-special">
    <div v-if="error" class="error">
        {{ error.message ? error.message : $tr('common.errrorLoadingPageContent') }}
    </div>
    <div v-else-if="loading">
        loading . . .
    </div>
    <div v-else>
      <div class="row-block">
        <div>
          <label>{{ $tr('vacancy.preferences.special.idExternal') }}</label>
          <input
            name="id-external"
            type="number"
            v-model="idExternal"
          />
        </div>
        <div class="help">
          <span>{{ $tr('vacancy.preferences.special.idExternalHelper') }}</span>
        </div>
      </div>
      <div class="button-wrapper">
        <vbutton label="common.save" @click="save"/>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'process-vacancy-preferences-special',

  computed: {
    vacancy () {
      return this.$store.getters['vacancy/one']
    },

    store () {
      return this.$store.state.process.citibank.vacancy.additionalData
    },

    loading () {
      return this.store.loading
    },

    error () {
      return this.store.error
    },

    data () {
      return this.store.data
    },

    idExternal: {
      get () {
        return this.$store.getters['process/citibank/vacancy/additionalData/idExternal']
      },
      set (value) {
        let numberValue
        if (value !== '') {
          numberValue = Number(value)
        }
        this.change('id_external', numberValue)
      }
    }
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/citibank/vacancy/additionalData/fetch', this.vacancy)
    },
    change (field, value) {
      this.$store.dispatch('process/citibank/vacancy/additionalData/update', {field, value})
    },
    save() {
      this.$store.dispatch('process/citibank/vacancy/additionalData/save', this.vacancy)
    }
  },

  beforeMount() {
    this.fetch()
  },

  mounted () {
    // add event listener for common save button click
    // double $parent, because of use of proxy component: Component where event occur -> Special (proxy) -> SpecialProcess (our)
    // this.$parent.$parent.$on('saveOnParent', () => {
    //  this.$store.dispatch('process/citibank/vacancy/additionalData/save', this.vacancy)
    // })
  },

  destroyed () {
    // Handler is not removed, because we must save changed data even after leaving special process tab
    // this.$parent.$off('saveOnParent')
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../styles/colors.scss";

  .preferences-special {
    margin-top: 30px;
    margin-bottom: 30px;

    .row-block {
      display: flex;
      margin: 40px 0 40px 0;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 1000px;

      & > div:first-child {
        width: calc(60% - 40px);
        margin-right: 40px;
      }

      div.help {
        padding-top: 28px;
        width: 40%;

        span {
          display: block;
          padding: 10px 15px;
          border-radius: 5px;
          background-color: $line-statuses-status-settings-bg;
        }
      }

      label {
        font-size: 16px;
        display: block;
        margin-bottom: 10px;
      }

      input {
        max-width: 200px;
        min-height: 26px;
        font-size: 16px;
      }
    }
  }
</style>
